import Resource from "nvent-web/services/resources/Resource";
import { LevelWithNestedElements } from "nvent-web/types/Level";

export default class LevelResource extends Resource {
  getOne({ projectId, levelId }: { projectId: number; levelId: number }) {
    return this.http.get<LevelWithNestedElements>(`/admin/projects/${projectId}/levels/${levelId}`);
  }
}
